<template>
  <div @click="$emit('click')" class="cta" :class="ctaStyle">
    <div class="position-relative" :class="{ 'p mt-0': ctaStyle === 'secondary', 'p-2': ctaStyle === 'quaternary' }">
      {{ label }}
      <div v-if="labelBold" class="font-weight-bold title-bold ml-2">{{ labelBold }}</div>
      <div class="icon">
        <svg
          width="8px"
          height="14px"
          viewBox="0 0 6 12"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-327.000000, -735.000000)" fill="#19222b">
              <g transform="translate(322.000000, 733.000000)">
                <path
                  d="M5.55079926,2.83335079 L5.08134126,3.30278508 C4.97023059,3.41389575 4.97023059,3.59405343 5.08134126,3.70518781 L9.36593096,7.99999704 L5.08134126,12.2948063 C4.97023059,12.4059169 4.97023059,12.5860746 5.08134126,12.697209 L5.55079926,13.166667 C5.66190994,13.2777777 5.84206762,13.2777777 5.953202,13.166667 L10.9186587,8.20121026 C11.0297694,8.09009959 11.0297694,7.90994191 10.9186587,7.79880752 L5.953202,2.83335079 C5.84206762,2.7222164 5.66190994,2.7222164 5.55079926,2.83335079 Z"
                  id="Icon-/-System-/-Small-/-far_fa-chevron-right"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'CTA',
  props: {
    label: {
      type: String,
    },
    labelBold: {
      type: String,
      required: false,
    },
    ctaStyle: {
      type: String,
      validator: str => ['default', 'secondary', 'tertiary', 'quaternary'].indexOf(str) > -1,
    },
    inLineIcon: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';
.cta {
  border-radius: 6px;
  border: 1px solid rgb(218, 226, 234);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  padding: 16px 40px 16px 24px;
  position: relative;
  margin-bottom: 0.5rem;
  transition: all 100ms linear;
  cursor: pointer;
  &.secondary {
    padding: 24px 40px 24px 24px;
  }
  &.tertiary {
    text-align: center;
    padding: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .icon {
      display: none;
    }
  }
  &.quaternary {
    border: 0;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  }
  &:last-of-type {
    margin-bottom: 0;
  }
  .icon {
    position: absolute;
    top: 50%;
    right: -20px;
    margin-top: -12px;
    transition: right 100ms linear;
  }
  .icon-inline {
    transition: right 100ms linear;
  }
  &:hover {
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.15);
    .icon,
    .icon-inline {
      svg path {
        fill: $primary !important;
      }
    }
  }
  .title-bold {
    color: #19222b;
    display: inline-block;
  }
}
</style>
